import { CellContext, ColumnDefTemplate } from "@tanstack/react-table";

import { ThumbnailOverlay } from "#shared/view/components/Thumbnails/ThumbnailOverlay";
import { QuoteRequestLinesListItem } from "#types/QuoteRequestLinesListItem";
export const ImageCell: ColumnDefTemplate<CellContext<QuoteRequestLinesListItem, string>> = ({
  row,
}) => {
  return <ThumbnailOverlay part={row.original.part} quoteRequestLineId={row.original.id} />;
};
